import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionEventsDashboardPage } from '@/modules/subscription-events/pages/SubscriptionEventsDashboardPage';

export const Route = createFileRoute('/dashboard/analytics/subscription-events/')({
  component: SubscriptionEventsDashboardPage,
});
